import { Spin } from 'antd';
import { StyledPreviewTask } from './PreviewTask.styled';
import { useEffect, useMemo } from 'react';
import PreviewTaskBody from './PreviewTaskBody.jsx/PreviewTaskBody';
import useGetTaskQuery from '@/v2/domains/Tasks/queries/useGetTaskQuery.hook';
import openAPIErrorNotification from '../APIErrorNotification/APIErrorNotification';

export default function PreviewTask({
  taskTemplate,
  taskActivities,
  taskId,
  onClose,
  loading,
}) {
  const { data: task, isError } = useGetTaskQuery({ taskId });

  const taskWithTaskActivities = useMemo(() => {
    if (task) {
      return task;
    } else if (taskTemplate) {
      return {
        ...taskTemplate,
        id: null,
        taskActivities: [...taskTemplate.taskTemplateActivities],
      };
    } else if (taskActivities) {
      return {
        id: null,
        taskActivities: [...taskActivities],
      };
    }
    return null;
  }, [task, taskActivities, taskTemplate]);

  useEffect(() => {
    if (isError) {
      openAPIErrorNotification({
        title: 'There was an error',
        description: 'The task could not be loaded',
      });
      onClose();
    }
  }, [isError]);

  return (
    <StyledPreviewTask
      visible={taskId || taskTemplate || taskActivities}
      centered
      closable={false}
      width="100%"
      height="100%"
      destroyOnClose
      footer={null}
    >
      {loading || !taskWithTaskActivities ? (
        <div className="loading">
          <Spin spinning />
        </div>
      ) : (
        <PreviewTaskBody task={taskWithTaskActivities} onClose={onClose} />
      )}
    </StyledPreviewTask>
  );
}
